export const cssBundleHref = "/build/css-bundle-HXTIWQUP.css";